var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 807 1109",
    style: {
      enableBackground: "new 0 0 807 1109"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.8,555.2l-0.5,3c-0.1,0.5,0.1,1.1,0.5,1.4c0.3,0.3,0.7,0.5,1.2,0.5c0.1,0,0.2,0,0.3,0l3-0.5 c0.3-0.1,0.7-0.2,0.9-0.5l9.3-9.3c0.6-0.6,1-1.5,1-2.4s-0.4-1.8-1-2.4c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-9.3,9.3 C399,554.5,398.8,554.8,398.8,555.2L398.8,555.2z M409.5,546c0.4-0.4,0.9-0.6,1.5-0.6c0.6,0,1.1,0.2,1.5,0.6 c0.4,0.4,0.6,0.9,0.6,1.5c0,0.6-0.2,1.1-0.6,1.5l-1.4,1.4l-2.9-2.9L409.5,546z M400.1,555.4c0-0.1,0-0.1,0.1-0.2l6.9-6.9l2.9,2.9 l-6.9,6.9c0,0-0.1,0.1-0.2,0.1l-3,0.5c-0.1,0-0.2,0-0.3-0.1c0,0-0.1-0.1-0.1-0.3L400.1,555.4z M400.1,555.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413.7,552.1c-0.4,0-0.7,0.3-0.7,0.7v9.3c0,1.6-1.3,2.9-2.9,2.9h-13.8c-1.6,0-2.9-1.3-2.9-2.9v-13.8 c0-1.6,1.3-2.9,2.9-2.9h9.3c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7h-9.3c-2.4,0-4.3,1.9-4.3,4.3v13.8c0,2.4,1.9,4.3,4.3,4.3h13.8 c2.4,0,4.3-1.9,4.3-4.3v-9.3C414.4,552.4,414,552.1,413.7,552.1L413.7,552.1z M413.7,552.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/게시판.9fd50a91f186a9b64ba4cff5c9d27fa3.svg";
export { ForwardRef as ReactComponent };